module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/serviceregister/incrementdetails/incrementdetails-form/incrementdetails-form.component.css
// module id = ./src/app/hrms/serviceregister/incrementdetails/incrementdetails-form/incrementdetails-form.component.css
// module chunks = main